(function ($) {
    "use strict";

    $(function () {

        if (window.getComputedStyle(document.documentElement).scrollBehavior !== 'smooth') {
            const links = document.querySelectorAll('a[href^="#"]');
            links.forEach((link) => {
                const target = document.querySelector(link.getAttribute('href'));
                if (target) {
                    link.addEventListener('click', (event) => {
                        event.preventDefault();
                        target.scrollIntoView({ behavior: 'smooth' });
                    });
                }
            });
        }




    });
})(jQuery);
